import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DatatableColumn } from 'projects/bis-shared/src/lib/datatable/datatable-column';
import { DatatableColumnWidth } from 'projects/bis-shared/src/lib/datatable/datatable-column-width';
import { DatatableSort } from 'projects/bis-shared/src/lib/datatable/datatable-sort';
import { DatatableStaticTemplateType } from 'projects/bis-shared/src/lib/datatable/datatable-static-template';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import * as moment from 'moment-timezone';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';
import { ObjectTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { Moment } from 'moment-timezone';
import { FilterDataType } from 'projects/bis-shared/src/lib/datatable/datatable-filter/filter-operations';

@Component({
  selector: 'app-active-prior-auth-list-insurer-my-pars-component',
  templateUrl: './active-prior-auth-list-insurer-my-pars.component.html',
  styleUrls: ['./active-prior-auth-list-insurer-my-pars.component.scss'],
})
export class ActivePriorAuthListInsurerMyParsComponent implements OnInit {
  @ViewChild('idTemplate', { static: true }) idTemplate: TemplateRef<any>;
  @ViewChild('injuryDateTemplate', { static: true }) injuryDateTemplate: TemplateRef<any>;
  columns: DatatableColumn[];
  filterColumn: string[];
  dataUrl: string;
  defaultSort: DatatableSort[];
  AppUrls = AppUrls;
  lastLoginDate: Moment = this.identityService.apiToken.lastLoginDateTime;
  priorAuthTypeCode = ObjectTypeCode.PriorAuthorization;

  constructor(private identityService: IdentityService, private externalApiUrls: ExternalApiUrls) {
    this.defaultSort = [
      {
        property: 'dueDate',
        sortAscending: true,
      },
      {
        property: 'patient',
        sortAscending: true,
      },
    ];
  }

  ngOnInit() {
    this.setColumns();
    this.dataUrl = this.externalApiUrls.priorAuthorization.priorAuthorizationWorkRequestLevel();
  }

  setColumns() {
    this.columns = [
      {
        title: 'PAR ID',
        property: 'priorAuthorizationId',
        filterDataType: FilterDataType.SystemId,
        filterSystemIdFixedTypeCode: ObjectTypeCode.PriorAuthorization,
        template: this.idTemplate,
        width: 150,
      },
      {
        title: 'Type',
        property: 'priorAuthorizationRequestType',
        filterDataType: FilterDataType.Reference,
      },
      {
        title: 'Due Date',
        property: 'dueDate',
        filterDataType: FilterDataType.DateTime,
        template: DatatableStaticTemplateType.EasternDateTemplate,
        width: DatatableColumnWidth.medium,
      },
      {
        title: 'PAR Status',
        property: 'priorAuthStatus',
        filterDataType: FilterDataType.Reference,
      },
      {
        title: 'RFI',
        property: 'latestRFIState',
        filterDataType: FilterDataType.Reference,
        titleToolTip: 'Request for Further Information from Provider',
        width: DatatableColumnWidth.small,
      },
      {
        title: 'Patient',
        property: 'patient',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'Claim Admin Claim #',
        property: 'carrierCaseNumber',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'WCB Case #',
        property: 'wcbCaseNumber',
        filterDataType: FilterDataType.String,
        template: DatatableStaticTemplateType.CaseNumberTemplate,
        width: DatatableColumnWidth.large,
      },
      {
        title: 'Injury Date',
        property: 'dateOfInjury',
        filterDataType: FilterDataType.Date,
        width: DatatableColumnWidth.medium,
        template: this.injuryDateTemplate,
      },
      {
        title: 'Assigned Organization',
        property: 'assignedOrganization',
        filterDataType: FilterDataType.String,
      },
      { title: 'Claim Admin', property: 'claimAdminName', filterDataType: FilterDataType.String },
      {
        title: 'Employer Name',
        property: 'employerName',
        filterDataType: FilterDataType.String,
      },
      { title: 'Insurer', property: 'insurerName', filterDataType: FilterDataType.String },
      { title: 'Provider', property: 'provider', filterDataType: FilterDataType.String },
      {
        title: 'Current Activity',
        property: 'workRequestName',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'PAR Status Date',
        property: 'priorAuthStatusDate',
        filterDataType: FilterDataType.Date,
        template: DatatableStaticTemplateType.EasternDateTimeHMSTemplate,
      },
      {
        title: 'DOB',
        property: 'dateOfBirth',
        filterDataType: FilterDataType.Date,
        template: DatatableStaticTemplateType.UtcDateTemplate,
      },

      {
        title: 'Medication',
        property: 'medicationRequested',
        filterDataType: FilterDataType.String,
      },
    ];
  }

  getRowClass = (row: any) => {
    if (
      moment(row.workRequestUpdateDate).isAfter(this.lastLoginDate) ||
      moment(row.latestRFIStateDT).isAfter(this.lastLoginDate)
    ) {
      return 'row-highlight';
    } else {
      return '';
    }
  };
}
